import { News } from "@mais-retorno-front/core-business/entities/news"
import { AssetRelatedNewsUseCase } from "@mais-retorno-front/core-business/useCases/news/asset-related-news.usecase"
import { getPostsBySearchTerm } from "@mais-retorno-front/graphQl/queries/unified-search";

export const makeAssetRelatedNews = () => {
  const newsEntity = new News();

  return new AssetRelatedNewsUseCase(
    newsEntity,
    getPostsBySearchTerm
  )
}